import { dominosStore } from '../../../main';
import { getPizzaOptionsAsString } from '../../../modules/OrderSummupDelivery/helpers';

declare global {
    interface Window {
        dataLayer: any;
    }
}

export const productTypes = {
    1: 'configurator pizza',
    2: 'promotion',
    98: 'simple product',
    99: 'creator pizza'
};
export const dataLayerPush = (eventName: string, evParams: EvParams, ecommerce?: any) => {
    if (typeof window.dataLayer !== 'undefined') {
        const dLayerParams: DataLayerType = {
            'event': eventName,
            'eventParam1': evParams.evParam1 || undefined,
            'eventParam2': evParams.evParam2 || undefined,
            'eventParam3': evParams.evParam3 || undefined,
            'eventParam4': evParams.evParam4 || undefined,
            'eventParam5': evParams.evParam5 || undefined
        };

        if (ecommerce) {
            //important notice - have to place object keys as string 'obj.key' !!! within ecommerce object
            dLayerParams['ecommerce'] = ecommerce;
        }

        window.dataLayer.push(dLayerParams);
    }
};

export const createLayerImpressions = (products: AppProduct[]) => {
    let impressions: DataLayerProductImpressionType[] = [];
    if (typeof products != 'undefined') {
        products.map((p, index) => {
            let singleProductImpression = {
                'name': p.Name,
                'brand': 'Dominos',
                'category': productTypes[p.Type],
                'list': dominosStore.cartStore.currentMenuCategory,
                // index + 1 creates real position instead of array index
                'position': index + 1,
            };
            impressions.push(singleProductImpression);
        });
    }
    return impressions;
};

export const createLayerProducts = (products?: AppCartProduct[]) => {
    let productsArray: DataLayerSingleProductType[] = [];
    if (!products) {
        dominosStore.cartStore.products.map(product => {
            const prod = createLayerSingleProduct(product);

            productsArray.push(prod);
        });
    } else {
        products.map(product => {
            const prod = createLayerSingleProduct(product);
            productsArray.push(prod);
        });
    }
    return productsArray;
};

export const createLayerSingleProduct = (product: AppCartProduct) => {
    const prod: DataLayerSingleProductType = {
        'name': product.Data.Name,
        'price': product.Data.Sum,
        'brand': 'Dominos',
        'category': productTypes[product.Type],
        'variant': '',
        'quantity': product.Data.Count,
        'coupon': ''
    };
    switch (product.Type) {
        case 1:
            prod['variant'] =
                product.Data.Name.toUpperCase() + ', ' + getPizzaOptionsAsString(product.Data);
            break;
        case 99:
            prod['variant'] = product.Data.CartPizzas.map(
                p => p.Name.toUpperCase() + ', ' + getPizzaOptionsAsString(p)
            ).join(', ');
            break;
        case 2:
            prod['coupon'] = product.Data.Name;
            prod['variant'] = product.Data.CartGroups.map(
                group =>
                    group.CartPizzas.map(
                        p => p.Name.toUpperCase() + ', ' + getPizzaOptionsAsString(p)
                    ).join(', ') +
                    group.CartProducts.map(p =>
                        p.Count > 1 ? p.Name + ' x ' + p.Count : p.Name
                    ).join(', ')
            ).join(', ');
            break;
        case 98:
            prod['variant'] = product.Data.Name.toUpperCase();
            break;
    }
    return prod;
};

export const createLayerSimpleProduct = (name: string, price: number, count: number) => {
    const prod: DataLayerSingleProductType = {
        'name': name,
        'price': price,
        'brand': 'Dominos',
        'category': productTypes[98],
        'variant': name.toUpperCase(),
        'quantity': count,
        'coupon': ''
    };
    return prod;
};

export const createGA4LayerSimpleProduct = (
    id: string, 
    name: string,
    index: number, 
    item_brand: string,
    item_category: string,
    item_list_name: string,
    /* zmienione 19.01.2026 */
    item_category2: string,
    item_category3: string,
    /* zmienione 19.01.2026 */
    item_variant: string,
    price: number, 
    count: number,
    coupon?: string
) => {
    const prod: NewDataLayerSingleProductType = {
        'item_id': id,
        'item_name': name,
        'index': index,
        'item_brand': 'Dominos',
        'item_list_name': item_list_name,
        'item_category': productTypes[98],
        /* zmienione 19.01.2026 */
        'item_category2': item_category2,
        'item_category3': item_category3,
        /* zmienione 19.01.2026 */
        'item_variant': item_variant,
        'price': price,
        'quantity': count,
        'coupon': coupon,
    };
    return prod;
};

export const createLayerPizzaProduct = (
    pizza: CartPizzaProduct,
    name: string,
    price: number,
    analyticsOptions: CartProductResponse[],
    analyticsSizeName: string,
    analyticsFlavorName: string
) => {
    const prod: DataLayerSingleProductType = {
        'name': name,
        'price': price,
        'brand': 'Dominos',
        'category': productTypes[1],
        'variant':
            name.toUpperCase() +
            ', ' +
            createPizzaOptionsForAnalytics(
                analyticsOptions,
                analyticsSizeName,
                analyticsFlavorName
            ),
        'quantity': pizza.Count,
        'coupon': ''
    };

    return prod;
};

export const createGA4LayerPizzaProduct = (
    id: string,
    name: string,
    index: number,
    item_brand: string,
    item_category: string,
    item_list_name: string,
    /* zmienione 19.01.2026 */
    item_category2: string,
    item_category3: string,
    /* zmienione 19.01.2026 */
    item_variant: string,
    price: number,
    count: number,
    coupon?: string,
) => {
    const prod: NewDataLayerSingleProductType = {
        'item_id': id,
        'item_name': name,
        'index': index,
        'item_brand': 'Dominos',
        'item_list_name': item_list_name,
        'item_category': productTypes[1],
        /* zmienione 19.01.2026 */
        'item_category2': item_category2,
        'item_category3': item_category3,
        /* zmienione 19.01.2026 */
        'item_variant': item_variant,
        'price': price,
        'quantity': count,
        'coupon': coupon,
    };

    return prod;
};


export const createLayerCreatorProduct = (
    creator: CartCreatorProduct,
    name: string,
    price: number,
    analyticsOptionsBundle: CreatorOptionsAnalytics,
    analyticsNames: string[],
    analyticsSizeNames: string[],
    analyticsFlavorNames: string[]
) => {
    const prod: DataLayerSingleProductType = {
        'name': name,
        'price': price,
        'brand': 'Dominos',
        'category': productTypes[99],
        'variant': createCreatorOptionsForAnalytics(
            analyticsOptionsBundle,
            creator,
            analyticsNames,
            analyticsSizeNames,
            analyticsFlavorNames
        ),
        'quantity': creator.Count,
        'coupon': ''
    };

    return prod;
};

export const createGA4LayerCreatorProduct = (
    id: string,
    name: string,
    index: number,
    item_brand: string,
    item_category: string,
    item_category2: string,
    item_category3: string,
    item_variant: string,
    price: number,
    count: number,
    coupon?: string,
) => {
    const prod: NewDataLayerSingleProductType = {
        'item_id': id,
        'item_name': name,
        'index': index,
        'item_brand': 'Dominos',
        'item_category': productTypes[1],
        /* zmienione 19.01.2026 */
        'item_category2': item_category2,
        'item_category3': item_category3,
        /* zmienione 19.01.2026 */
        'item_variant': item_variant,
        'price': price,
        'quantity': count,
        'coupon': coupon,
    };

    return prod;
};

export const createLayerPromotionProduct = (
    coupon: CartCouponProduct,
    name: string,
    analyticsPromotionData: AnalyticsStepObj[]
) => {
    const prod: DataLayerSingleProductType = {
        'name': name,
        'price': undefined,
        'brand': 'Dominos',
        'category': productTypes[2],
        'variant': createPromotionOptionsForAnalytics(analyticsPromotionData),
        'quantity': coupon.Count,
        'coupon': name
    };

    return prod;
};

export const createGA4LayerPromotionProduct = (
    id: string,
    name: string,
    index: number,
    item_brand: string,
    item_category: string,
    /* zmienione 19.01.2026 */
    item_category2: string,
    item_category3: string,
    /* zmienione 19.01.2026 */
    item_variant: string,
    price: number,
    count: number,
    coupon?: string,
) => {
    const prod: NewDataLayerSingleProductType = {
        'item_id': id,
        'item_name': name,
        'index': index,
        'item_brand': 'Dominos',
        'item_category': productTypes[2],
        /* zmienione 19.01.2026 */
        'item_category2': item_category2,
        'item_category3': item_category3,
        /* zmienione 19.01.2026 */
        'item_variant': item_variant,
        'price': price,
        'quantity': count,
        'coupon': coupon,
    };

    return prod;
};

export const createPizzaOptionsForAnalytics = (
    options: CartProductResponse[],
    size: string,
    flavour: string
) => {
    const dip = options
        .filter((p: CartProductResponse) => p.isDip && p.Count > 0)
        .map(p => p.Name)
        .join();
    const added = options
        .filter((p: CartProductResponse) => !p.isDip && p.Count > p.DefaultCount)
        .map(p => p.Name)
        .join(', +');
    const removed = options
        .filter((p: CartProductResponse) => !p.isDip && p.Count < p.DefaultCount)
        .map(p => p.Name)
        .join(', -');

    let details = `${size}, ${flavour}, ${dip}`;
    if (added) {
        details += `, +${added}`;
    }
    if (removed) {
        details += `, -${removed}`;
    }

    return details;
};

const createCreatorOptionsForAnalytics = (
    analyticsOptionsBundle: CreatorOptionsAnalytics,
    creator: CartCreatorProduct,
    analyticsNames: string[],
    analyticsSizeNames: string[],
    analyticsFlavorNames: string[]
) => {
    const variant = creator.CartPizzas.map((p: CartPizzaProduct, index: number) => {
        return (
            analyticsNames[index].toUpperCase() +
            ', ' +
            createPizzaOptionsForAnalytics(
                analyticsOptionsBundle[index as keyof CreatorOptionsAnalytics],
                analyticsSizeNames[index],
                analyticsFlavorNames[index]
            )
        );
    }).join(', ');

    return variant;
};

const createPromotionOptionsForAnalytics = (analyticsPromotionData: AnalyticsStepObj[]) => {
    const variant = analyticsPromotionData
        .map(step => {
            if (step.cartPizza) {
                return (
                    step.cartPizza.name +
                    ', ' +
                    createPizzaOptionsForAnalytics(
                        step.cartPizza.options,
                        step.cartPizza.sizeName,
                        step.cartPizza.flavorName
                    )
                );
            }
            if (step.cartProduct) {
                return step.cartProduct.count > 1
                    ? step.cartProduct.name + ' x ' + step.cartProduct.count
                    : step.cartProduct.name;
            }
        })
        .join(', ');

    return variant;
};
